import { useTheme } from '@mui/material';

import React, { useContext, useEffect, useState } from 'react';
import __t from "../../../lib/traduzioni";
import currencies from '../../../currencies';
import {differenceInSeconds} from 'date-fns'
import useBSSLogger from '../../../hooks/useBSSLogger';
import BSSPreventivoContext from '../../../contexts/BSSPreventivoContext';
import NotePrezzo from './NotePrezzo';
import NumPrezziProposti from './NumPrezziProposti';
import OrdinaPrezzi from './OrdinaPrezzi';
import { filtraPreventivi } from './utils/funzioni';
import Prezzo from './Prezzo';
import {StatoComparatoreProvider} from './contexts/StatoComparatore';
import PopperAddizionale from './PopperAddizionale';


const {logger} = useBSSLogger();

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const ComparatorePrezzi = ({preventivi = {}, immaginepreventivodefault, methods, onSubmit, clauses, setClauses}) => {

    
    const [expanded, setExpanded] = useState({})
    const [statoPopperAddizionale, setStatoPopperAddizionale] = useState({})

    /**
    * @type [ResPreventivo, Function]
    */
    const [mostraNotePreventivo, setMostraNotePreventivo] = useState({preventivoSelezionato: null, mostra: false});
    /**
     * @type {{quotations: ResPreventivo[], currency: String, listaCategorieAddizionali: ResCategorieAddizionaliType[]}}
     */
    const {quotations: dati = [], currency = "EUR", listaCategorieAddizionali = []} = preventivi;    
    const valuta = currencies[currency];
    const categoriaById = listaCategorieAddizionali.reduce((obj, cat) => {
        obj[cat.id] = cat
        return obj;
    }, {})    

    /**
     *  
     * @param {ResPreventivo} p1 
     * @param {ResPreventivo} p2 
     */
    const applicaSort = (p1, p2) => {
        const {sort} = clauses;
        const {field, dir = "asc"} = sort

        let verso = 0, p1val = null, p2val = null;

        if(field === "totalprice"){
            p1val = Number(p1.totalprice);
            p2val = Number(p2.totalprice);
        }

        if(field === "deliverydate"){
            const now = new Date();
            p1val = differenceInSeconds(p1.deliverydate, now);
            p2val = differenceInSeconds(p2.deliverydate, now);
            
        }

        if(dir === 'asc' && !isNaN(p1val) && !isNaN(p2val) && p1val !== null && p2val !== null){
            verso = p1val - p2val
        } else {
            verso = p2val -p1val
        }

        return verso;
    }    

    /**
     * 
     * @param {ResPreventivo} p 
     */
    const applicaFilter = (p) => {
        const {filter} = clauses;
        const esito = filtraPreventivi({preventivo: p, filter});
        return esito;
    }

    const npreventivi = (dati ?? []).length;
    const coniuglabel = npreventivi > 1 ? "fp" : "fs";

    const datiFiltrati = (dati ?? [])
        .filter(applicaFilter)
        .sort(applicaSort);

    const ndatiFiltrati = datiFiltrati.length;
    const coniuglabelfiltro = ndatiFiltrati > 1 ? "fp" : "fs";
    
    //da tutte le quotazioni vengono estrapolati tutti gli addizionali e messi in una mappa <[idaddzionale], addizionale>
    const addizionaliById = dati.reduce((obj, preventivo) => {
        preventivo.listaaddizionali.forEach(addizionale => {
            obj[addizionale.id] = addizionale
        })
        return obj;
    }, {})


    return (
        <>
            <StatoComparatoreProvider value={{setExpanded, expanded, methods, categoriaById, addizionaliById, statoPopperAddizionale, setStatoPopperAddizionale}}>
                
                <PopperAddizionale />
                
                <NotePrezzo {...{setMostraNotePreventivo, mostraNotePreventivo}} />

                <center>
                    <NumPrezziProposti {...{coniuglabel, coniuglabelfiltro, ndatiFiltrati, npreventivi}} />
                </center>

                <OrdinaPrezzi {...{clauses, ndatiFiltrati, setClauses}} />

                {datiFiltrati.map(
                    /**
                     * 
                     * @param {ResPreventivo} preventivo 
                     * @param {*} indicePreventivo 
                     * @returns 
                     */
                    (preventivo, indicePreventivo) => {
                        return <Prezzo key={preventivo.price.id} {...{preventivo, indicePreventivo, immaginepreventivodefault, onSubmit, setMostraNotePreventivo, dati, valuta}} />
                    })
                }
            </StatoComparatoreProvider>
        </>
    )

}

export default ComparatorePrezzi;
